import { useState, useEffect } from 'react';
import { getClientInitials } from '../utils/dataModel';

/**
 * Client logo with a fallback that actually renders something.
 *
 * The previous inline fallback swapped in a div containing `project.icon`, but only
 * one of the eight projects defines an icon — so a failed logo left an empty box.
 */
const ProjectLogo = ({ project, className = '' }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [project.id]);

  if (failed) {
    return (
      <div className={`project-logo-initials ${className}`} aria-hidden="true">
        {getClientInitials(project.client_name)}
      </div>
    );
  }

  return (
    <img
      src={project.logo}
      alt={`${project.client_name} logo`}
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

export default ProjectLogo;
